import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id 933B83F8-4F97-436F-89E0-574315FF1E2E
 * name axis-x-arrow
 * version: 3.4.93
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/axis-x-arrow.svg
 * tags
 * - Arrow 
 */
export const AxisXArrowIcon = createSvgIcon(<><path d="M1.5,20.5L3,15.03L4.46,17.6L11,13.82V3H13V13.82L22.39,19.25L21.39,21L12,15.56L5.46,19.33L7,21.96L1.5,20.5Z" /></>, 'AxisXArrowIcon');
export default AxisXArrowIcon